import { useTranslations } from "next-intl";
import { useRef } from "react";
import {
  useReviewShortOffcanvasOpened,
  useCloseReviewShortOffcanvas,
  useReviewShortFinished,
  useReviewShortCloset,
} from "@hooks/use-review-short";
import Offcanvas from "@components/core/Offcanvas";
import ClosetItemsToReview from "./ClosetItemsToReview";
import ClosetItemReviewShort from "./ClosetItemReviewShort";
import ShortReviewsFinished from "./ShortReviewsFinished";
import useCustomizableCloset, { useReloadCustomizableCloset } from "@hooks/use-customizable-closet";

function ReviewShortOffcanvas() {
  const t = useTranslations("common");

  const offcanvasBodyRef = useRef();

  const isOpen = useReviewShortOffcanvasOpened();
  const closeReviewShortOffcanvas = useCloseReviewShortOffcanvas();
  const reviewShortFinished = useReviewShortFinished();
  const currentCloset = useCustomizableCloset();
  const closetInReview = useReviewShortCloset();
  const reloadCurrentCloset = useReloadCustomizableCloset();

  function close() {
    if (closetInReview?.id === currentCloset?.id) reloadCurrentCloset();

    closeReviewShortOffcanvas();
  }

  function scrollToTop() {
    offcanvasBodyRef.current.scrollTo({ top: 0, behavior: "instant" });
  }

  function displayContent() {
    if (!isOpen) return <div className="d-flex flex-grow-1 bg-base" />;

    if (reviewShortFinished) {
      return <ShortReviewsFinished close={close} />;
    }

    return (
      <>
        <ClosetItemsToReview />
        <ClosetItemReviewShort scrollToTop={scrollToTop} />
      </>
    );
  }

  return (
    <Offcanvas
      show={!!isOpen}
      onHide={close}
      title={t("review_short.offcanvas_title")}
      placement="end"
      bodyRef={offcanvasBodyRef}
    >
      {displayContent()}
    </Offcanvas>
  );
}

export default ReviewShortOffcanvas;
